<template>
    <div class="py-4 px-5">
        <v-row no-gutters>
            <v-col cols="12">
                <v-tabs v-model="activeTab" style="border-radius: 16px; overflow: hidden">
                    <v-tab value="TaskCalendar" data-cy="tasks-calendar-tab">Calendrier</v-tab>
                    <!-- <v-tab value="TaskUserDashboard" href="#TaskUserDashboard" data-cy="tasks-tab">Tâches</v-tab> -->
                    <v-tab value="TaskRecurringDashboard" data-cy="tasks-recurring-tab"
                        >T&#xe2;ches Récurrentes</v-tab
                    >
                    <!-- <v-tab value="TaskTimeline" href="#TaskTimeline" data-cy="tasks-timeline">Timeline</v-tab> -->
                </v-tabs>
                <v-row no-gutters class="my-3">
                    <v-col cols="2" class="pr-2">
                        <v-btn-primary block @click="clearNewToTaskCreate()">Ajouter</v-btn-primary>
                    </v-col>
                    <v-col cols="2" class="pl-2">
                        <v-text-field
                            readonly
                            clearable
                            label="Créé par"
                            @click="openUserDialog"
                            @click:clear="clearUserSelectedFilter(selectedUser, 1)"
                            :model-value="displaySelectedUser(selectedUser)"
                            density="compact"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-2">
                        <v-text-field
                            readonly
                            clearable
                            label="Attribué à"
                            @click="openMemberDialog"
                            @click:clear="clearUserSelectedFilter(selectedMember, 2)"
                            :model-value="displaySelectedUser(selectedMember)"
                            density="compact"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-2" v-if="$router.currentRoute.value.name !== 'tasks'">
                        <v-select
                            v-model="companySelectedFilter"
                            :items="allAvailableCompanies"
                            :clearable="true"
                            outlined
                            item-value="id"
                            hide-details
                            label="Entreprises Tiers"
                            @click:clear="clearCompanySelectedFilter()"
                            density="compact"
                            :item-title="(item) => item.name"
                        >
                        </v-select>
                    </v-col>
                    <v-col v-if="activeTab !== 'TaskRecurringDashboard'" cols="2" class="pl-2">
                        <v-select
                            v-model="typeStatusFilter"
                            :items="typesStatus"
                            outlined
                            item-value="value"
                            hide-details
                            label="Statut"
                            @click:clear="clearStatusSelectedFilter()"
                            density="compact"
                            :item-title="(item) => item.name"
                        >
                        </v-select>
                    </v-col>
                    <v-col v-if="activeTab === 'TaskRecurringDashboard'" cols="3">
                        <DateRangePicker
                            class="d-flex pl-4"
                            v-bind:begin="startPeriodicityDate"
                            v-bind:end="endPeriodicityDate"
                            @change-dateRange="onDateRangeChanged"
                            :hideDetails="true"
                            :type="'month'"
                            dense
                        />
                    </v-col>
                    <!-- <v-col v-if="activeTab === 'TaskUserDashboard'" class="d-flex justify-end">
                        <v-switch
                            v-model="isRecurringTaskShow"
                            inset
                            color="primary"
                            class="d-flex pl-4 mt-1"
                            label="Tâches récurrente"
                        >
                        </v-switch>
                    </v-col> -->
                </v-row>
                <v-window v-model="activeTab" style="background-color: transparent !important">
                    <v-window-item value="TaskCalendar">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <TasksCalendar
                                    :accountingFirmId="accountingFirmId"
                                    :clientId="companySelectedFilter"
                                    :selectedUser="selectedUser"
                                    :selectedMember="selectedMember"
                                    :companySelectedFilter="companySelectedFilter"
                                    :typeStatusFilter="typeStatusFilter"
                                    :tasksFromParentComponent="tasksDatabase"
                                    @task-date="receiveTaskDate($event)"
                                    @edit-event="editTask($event)"
                                    v-if="accountingFirmId"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>

                    <v-window-item value="TaskRecurringDashboard">
                        <v-row
                            no-gutters
                            v-if="loadingTasks || !tasksRecurring || !tasksRecurring.length"
                        >
                            <v-col cols="12">
                                <v-card
                                    elevation="0"
                                    style="background-color: #ffffff; border-radius: 25px"
                                >
                                    <v-card-title
                                        v-if="loadingTasks"
                                        class="pa-4 d-flex justify-center"
                                    >
                                        <v-progress-circular indeterminate class="mr-3" />
                                    </v-card-title>
                                    <v-card-title
                                        v-else-if="!tasksRecurring || !tasksRecurring.length"
                                        class="pa-4 d-flex justify-center"
                                    >
                                        Pas de t&#xe2;ches récurrentes pour ce Collaborateur et/ou
                                        cette société
                                    </v-card-title>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-else no-gutters>
                            <v-col cols="12" class="pt-2">
                                <oss-data-table
                                    :headers="tasksRecurringTableHeaders"
                                    :items="tasksRecurring"
                                    :itemLength="tasksRecurringLength"
                                    :show-select="false"
                                    :x-dense="true"
                                    :striped="true"
                                    :table-hover="true"
                                    :fixed-footer="true"
                                    :fixed-header="true"
                                    checkbox-color="primary"
                                >
                                    <template v-slot:header.dueDate="{ header }">
                                        {{ displayHeaderDate(header.text) }}
                                    </template>
                                    <template v-slot:item="props">
                                        <tr @click="expandedRecurringTasksInTask(props.item)">
                                            <td>
                                                <!-- <v-menu absolute offset-y>
                                                    <template v-slot:activator="{ on, props }">
                                                        <v-btn
                                                        v-bind="props"
                                                        v-on="on"
                                                        icon
                                                        class="mx-1"
                                                        color="primary"
                                                        >
                                                            <v-icon>{{ on ? '$fa-chevron-up': '$fa-chevron-down'}}</v-icon>
                                                        </v-btn>
                                                    </template>
</v-menu> -->

                                                <v-btn
                                                    color="primary"
                                                    elevation="0"
                                                    class="mx-1"
                                                    @click.stop="
                                                        expandedRecurringTasksInTask(props.item)
                                                    "
                                                >
                                                    <v-icon>
                                                        {{
                                                            taskIdOfRecurringTaskExpanded(
                                                                props.item.id,
                                                            )
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"
                                                        }}
                                                    </v-icon>
                                                </v-btn>
                                            </td>
                                            <td>
                                                {{ formatCompany(props.item.client) }}
                                            </td>
                                            <!-- <td>
                                                {{formatUserTaskFrom(props.item.owner)}}
                                            </td> -->
                                            <td>
                                                {{ formatType(props.item.type) }}
                                            </td>
                                            <td>
                                                {{ props.item.title }}
                                            </td>
                                            <td>
                                                {{ props.item.description }}
                                            </td>
                                            <!-- <td>
                                                {{formatPeriodicity(props.item.periodicity)}}
                                            </td> -->
                                            <td
                                                v-for="(date, i) of rangeDates"
                                                :key="i"
                                                class="text-center"
                                            >
                                                <v-tooltip
                                                    v-if="
                                                        checkStartDateTask(date, props.item.tasks)
                                                    "
                                                    location="bottom"
                                                >
                                                    <template v-slot:activator="{ props }">
                                                        <v-avatar
                                                            :color="
                                                                changeColorTaskStatus(
                                                                    date,
                                                                    props.item.tasks,
                                                                )
                                                            "
                                                            size="20"
                                                            v-bind="props"
                                                            @click.stop="
                                                                changeTaskStatus(
                                                                    date,
                                                                    props.item.tasks,
                                                                    null,
                                                                    null,
                                                                )
                                                            "
                                                        >
                                                            <span
                                                                class="white--text font-weight-bold"
                                                            >
                                                                {{
                                                                    displayDateAvatar(
                                                                        props.item.start,
                                                                    )
                                                                }}
                                                            </span>
                                                            <!-- <v-menu
                                                                absolute
                                                                v-on="on"
                                                                offset-y
                                                            >
                                                                <template v-slot:activator="{ on, props }">
                                                                    <v-btn
                                                                        v-bind="props"
                                                                        v-on="on"
                                                                        icon
                                                                        class="mx-1"
                                                                    >
                                                                    </v-btn>
                                                                </template>
        <v-list>
            <v-list-item @click.stop="editTaskOfRecurringTask(date,props.item.tasks)">
                <v-list-item-title>Modifier</v-list-item-title>
                <template v-slot:append>
                                                                            <v-icon  size="small">$oss-edit</v-icon>
                                                                        </template>
            </v-list-item>
            <v-list-item @click.stop="deleteTaskOfRecurringTask(date,props.item.tasks)">
                <v-list-item-title>Supprimer</v-list-item-title>
                <template v-slot:append>
                                                                            <v-icon  size="small">$oss-trash</v-icon>
                                                                        </template>
            </v-list-item>
        </v-list>
        </v-menu> -->
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{
                                                        setStatusTaskOfRecurringTask(
                                                            date,
                                                            props.item.tasks,
                                                        )
                                                    }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td class="vertical-sticky-end">
                                                <v-menu absolute offset-y>
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn-icon
                                                            icon="$dots_vertical"
                                                            v-bind="props"
                                                            class="mx-1"
                                                            color="primary"
                                                        />
                                                    </template>
                                                    <v-list>
                                                        <v-list-item
                                                            @click.stop="editTask(props.item)"
                                                        >
                                                            <v-list-item-title>{{
                                                                props.item.auto === true
                                                                    ? "Visualiser"
                                                                    : "Modifier"
                                                            }}</v-list-item-title>
                                                            <template v-slot:append>
                                                                <v-icon
                                                                    v-if="props.item.auto === true"
                                                                    size="small"
                                                                    >$oss-eye</v-icon
                                                                >
                                                                <v-icon v-else size="small"
                                                                    >$oss-edit</v-icon
                                                                >
                                                            </template>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click.stop="deleteTask(props.item)"
                                                        >
                                                            <v-list-item-title
                                                                >Supprimer</v-list-item-title
                                                            >
                                                            <template v-slot:append>
                                                                <v-icon size="small"
                                                                    >$oss-trash</v-icon
                                                                >
                                                            </template>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </td>
                                        </tr>
                                        <tr v-if="taskIdOfRecurringTaskExpanded(props.item.id)">
                                            <td style="background: #f4f4f4" />
                                            <td
                                                :colspan="tasksRecurringTableHeaders.length"
                                                style="padding: 0; background: #f4f4f4"
                                                class="py-2 px-0"
                                            >
                                                <oss-data-table
                                                    :headers="tasksOfRecurringTaskTableHeaders"
                                                    :items="props.item.tasks"
                                                    :itemLength="
                                                        tasksOfRecurringTaskLength(props.item.tasks)
                                                    "
                                                    :show-select="false"
                                                    :x-dense="true"
                                                    :virtual-scroll="true"
                                                    :width="'100%'"
                                                    :displayRowNumber="true"
                                                    :striped="true"
                                                    :table-hover="true"
                                                    :fixed-footer="true"
                                                    :fixed-header="true"
                                                    checkbox-color="primary"
                                                    @clickRow="editTask($event)"
                                                >
                                                    <template v-slot:item.menu="{ item }">
                                                        <div class="d-flex justify-end">
                                                            <v-menu absolute offset-y>
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-btn-icon
                                                                        icon="$dots_vertical"
                                                                        v-bind="props"
                                                                        class="mx-1"
                                                                        color="primary"
                                                                    />
                                                                </template>
                                                                <v-list>
                                                                    <v-list-item
                                                                        @click.stop="editTask(item)"
                                                                    >
                                                                        <v-list-item-title>{{
                                                                            item.auto === true
                                                                                ? "Visualiser"
                                                                                : "Modifier"
                                                                        }}</v-list-item-title>
                                                                        <template v-slot:append>
                                                                            <v-icon
                                                                                v-if="
                                                                                    props.item
                                                                                        .auto ===
                                                                                    true
                                                                                "
                                                                                size="small"
                                                                                >$oss-eye</v-icon
                                                                            >
                                                                            <v-icon
                                                                                v-else
                                                                                size="small"
                                                                                >$oss-edit</v-icon
                                                                            >
                                                                        </template>
                                                                    </v-list-item>
                                                                    <v-list-item
                                                                        @click.stop="
                                                                            deleteTask(item)
                                                                        "
                                                                    >
                                                                        <v-list-item-title
                                                                            >Supprimer</v-list-item-title
                                                                        >
                                                                        <template v-slot:append>
                                                                            <v-icon size="small"
                                                                                >$oss-trash</v-icon
                                                                            >
                                                                        </template>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </div>
                                                    </template>
                                                    <!-- <template v-slot:item.owner="{ item }">
                                                        {{formatUserTaskFrom(item.owner)}}
                                                    </template> -->
                                                    <template v-slot:item.members="{ item }">
                                                        {{ formatSelectedUsers(item.members) }}
                                                    </template>
                                                    <template v-slot:item.dueDate="{ item }">
                                                        {{ formatDate(item.dueDate) }}
                                                    </template>
                                                    <template v-slot:item.start="{ item }">
                                                        {{ formatDate(item.start) }}
                                                    </template>
                                                    <!-- <template v-slot:item.client="{ item }">
                                                        {{formatCompany(item.client)}}
                                                    </template> -->
                                                    <!-- <template v-slot:item.type="{ item }">
                                                        {{formatType(item.type)}}
                                                    </template> -->
                                                    <template v-slot:item.status="{ item }">
                                                        <v-tooltip
                                                            v-if="statusIcon(item.status)"
                                                            location="start"
                                                        >
                                                            <template v-slot:activator="{ props }">
                                                                <v-icon
                                                                    :color="statusColor(item)"
                                                                    @click.stop="
                                                                        changeTaskStatus(
                                                                            date,
                                                                            null,
                                                                            item,
                                                                            null,
                                                                        )
                                                                    "
                                                                    size="small"
                                                                    v-bind="props"
                                                                >
                                                                    {{ statusIcon(item.status) }}
                                                                </v-icon>
                                                            </template>
                                                            <span>{{ statusText(item) }}</span>
                                                        </v-tooltip>
                                                    </template>
                                                </oss-data-table>
                                            </td>
                                        </tr>
                                    </template>
                                </oss-data-table>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
        <oss-dialog v-model="userDialog" :title="'Créé par'" max-width="800px">
            <select-user
                class="px-1"
                v-model="selectedUser"
                :companyId="accountingFirmId"
                :availableCompanyId="selectedCompany ? selectedCompany.id : ''"
                :type="'NATURAL_PERSON'"
                :withEmail="true"
                @user-selected="userDialog = false"
            />
        </oss-dialog>
        <oss-dialog v-model="memberDialog" :title="'Attribué à'" max-width="800px">
            <select-user
                class="px-1"
                v-model="selectedMember"
                :companyId="accountingFirmId"
                :availableCompanyId="selectedCompany ? selectedCompany.id : ''"
                :type="'NATURAL_PERSON'"
                :withEmail="true"
                @user-selected="memberDialog = false"
            />
        </oss-dialog>
        <!-- <oss-dialog
            v-model="dialogCompanySelection"
            v-if="dialogCompanySelection"
            :max-width="!$vuetify.display.mobile ? '800px':undefined"
            :min-height="!$vuetify.display.mobile ? '600px':undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Sélectionnez une société"
        >
                <template #content>
                <v-card-text class="pt-3">
                    <v-text-field
                        v-model="companySearch"
                        outlined
                        dense
                        label="Entrez le nom d'une société"
                        class="oss-"
                    >
                    </v-text-field>
                    <v-list style="overflow-y: auto; height:50vh" :value="selectedCompany.id">
                        <v-list-item
                            v-for="(company, index) in companyList"
                            :key="index"
                            :value="company.id"
                            @click="selectedCompany = company; dialogCompanySelection = false"
                            class="oss-list-item mb-2"
                        >
                            <v-list-item-title>
                                <div><strong>{{ getCompanyDisplayName(company) }}</strong></div>
                                <div class="overline">Siret: {{company.siret}}</div>
                            </v-list-item-title>
                            <template class="py-0">
                            <v-list-item-title>
                                {{getCompanyDisplayName(company)}}
                            </v-list-item-title>
                            <v-list-item-subtitle>Siret: {{company.siret}}</v-list-item-subtitle>
                            </template>
                            <template v-slot:append>
                                <v-icon color="grey lighten-1">$chevron_right</v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </template>
        </oss-dialog> -->
        <TaskDialog
            v-model="taskDialog"
            v-if="taskDialog"
            @task-created="receiveTask()"
            :tasksDatabase="tasksDatabase"
            :taskDate="taskDate"
            :isNewTask="isNewTask"
            :isEditTask="isEditTask"
            :taskToEdit="taskReceive"
        >
            <!-- :taskToEdit="taskToEdit" -->
        </TaskDialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import _ from "lodash";

import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import TASKS from "../../graphql/tasks/Tasks.gql";
import TasksCalendar from "./TasksCalendar.vue";
import TaskDialog from "./TaskDialog.vue";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import DELETE_TASK from "../../graphql/tasks/DeleteTasks.gql";
import UPSERT_TASK from "../../graphql/tasks/UpsertTasks.gql";
import moment from "moment-timezone";
import SelectUser from "../user/SelectUser.vue";
import USER from "../../graphql/user/User.gql";
import DateRangePicker from "../ossComponents/ossDateRangePicker.vue";
import OssCompanySelector from "../ossComponents/ossCompanySelector.vue";
import { getUserDisplayName } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        TasksCalendar,
        TaskDialog,
        OssDataTable,
        SelectUser,
        DateRangePicker,
        OssCompanySelector,
    },
})
export class Tasks extends Vue {
    activeTab: string = "TaskDashboard";

    taskDialog = false;

    userDialog = false;

    memberDialog = false;

    dialogCompanySelection = false;

    isNewTask = false;

    isEditTask = false;

    // showMenuRecurringTask = false

    loadingTasks = false;

    // isRecurringTaskShow = false

    // isExpandedRecurringTasksInTask = false

    // isTaskOfRecurringTaskDone = false

    startDateRangeHeader = null;

    endDateRangeHeader = null;

    rangeDates = [];

    companySelectedFilter = "";

    typeStatusFilter = "ALL";

    allAvailableCompanies = [];

    taskDate = "";

    companySearch = "";

    startPeriodicityDate = "";

    endPeriodicityDate = "";

    typesStatus = [
        {
            value: "ALL",
            name: "Tous",
        },
        {
            value: "TO_BE_DONE",
            name: "En cours",
        },
        {
            value: "DONE",
            name: "Terminée",
        },
    ];

    tasks = [];

    tasksRecurring = [];

    expandedTaskIdsInRecurringTask = [];

    taskReceive = {
        id: "",
        start: "",
        end: "",
        periodicity: "",
        dueDate: "",
        name: "",
        owner: {
            firstname: "",
            lastname: "",
        },
        description: "",
        type: "",
        status: "",
        members: [],
        client: {
            id: "",
            name: "",
        },
        recurringTask: {
            id: "",
        },
        tasks: [],
    };

    selectedUser = null;

    selectedMember = {
        email: "",
        firstname: "",
        id: "",
        lastname: "",
        type: "",
    };

    taskDeleleteIds = [];

    taskOfRecurringTaskId = "";

    // tasksFromDB = []

    beforeMount() {
        // debugger

        // this.clientId;

        if (this.$router.currentRoute.value.name === "tasks") {
            this.selectedUser = this.currentUser;
        }
        this.allAvailableCompanies = this.currentUser.allAvailableCompanies;
        this.typeStatusFilter = "ALL";
        this.startPeriodicityDate = moment().startOf("year").format("YYYY-MM-DD");
        this.endPeriodicityDate = moment().endOf("year").format("YYYY-MM-DD");

        if (this.$router.currentRoute.value.name !== "tasks") {
            this.companySelectedFilter = "";
        } else {
            this.companySelectedFilter = this.selectedCompany.id;
        }
    }

    // get tasksTableHeaders() {

    //     const header: Array<any> = [

    //         { text: "Tiers", value: "client", align: "left", sortable: true, filterable: { type: 'equals', options:{ toText: (client) => { return this.formatCompany(client) } } } },
    //         // { text: "Créé par", value: "owner", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (owner) => { return this.formatUserTaskFrom(owner)}}} },
    //         { text: "Type", value: "type", align: "left", sortable: true, filterable: { type: 'equals', options:{ toText: (type) => { return this.formatType(type) } } } },
    //         { text: "Titre", value: "title", align: "left", sortable: false },
    //         { text: "Description", value: "description", align: "left", sortable: false },
    //         { text: "Attribué à", value: "members", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (members) => { return this.formatSelectedUsers(members)}}} }, // Pas correct pour members
    //         // {text: "Début", value: "start", align: "center", sortable: true,},
    //         { text: "Date d'échéance", value: "dueDate", align: "left", sortable: true, filterable: { type: 'includes', options: { input: 'date' } } },
    //         { text: "Status", value: "status", align: "center", sortable: false },
    //         { text: '', value: 'id', sortable: false, verticalStickyEnd: true }
    //         // { text: "", value: "", sortable: false },
    //     ]

    //     // if (this.isRecurringTaskShow) {
    //     //     header.push()
    //     // }

    //     // header.push(

    //     // )

    //     return header

    // }

    get tasksRecurringTableHeaders() {
        this.rangeDates = [];

        const header: Array<any> = [
            { text: "", value: "", sortable: false },
            {
                text: "Tiers",
                value: "client",
                align: "left",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (client) => {
                            return this.formatCompany(client);
                        },
                    },
                },
            },
            // { text: "Créé par", value: "owner", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (owner) => { return this.formatUserTaskFrom(owner)}}} },
            {
                text: "Type",
                value: "type",
                align: "left",
                sortable: false,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (type) => {
                            return this.formatType(type);
                        },
                    },
                },
            },
            { text: "Titre", value: "title", align: "left", sortable: true },
            { text: "Commentaire", value: "description", align: "left", sortable: true },
            // { text: "Date d'échéance", value: "dueDate", align: "left", sortable: true, filterable: { type: 'includes', options: { input: 'date' } } },
            // { text: "Attribué à", value: "members", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (members) => { return this.formatSelectedUsers(members)}}} }, // Pas correct pour members
            // { text: "Récurrence", value: "periodicity", align: "left", sortable: true, filterable: { type: 'equals', options:{ toText: (periodicity) => { return this.formatPeriodicity(periodicity) } } } },
        ];

        this.startDateRangeHeader = this.formatDateHeader(this.startPeriodicityDate);
        this.endDateRangeHeader = this.formatDateHeader(this.endPeriodicityDate);

        // debugger
        while (this.startDateRangeHeader <= this.endDateRangeHeader) {
            this.rangeDates.push(this.startDateRangeHeader);
            this.startDateRangeHeader = this.nextDate(this.startDateRangeHeader);
        }

        for (const dateRange of this.rangeDates) {
            header.push({
                text: dateRange,
                value: "dueDate",
                align: "center",
                sortable: false,
            });
        }

        header.push({ text: "", value: "id", sortable: false, verticalStickyEnd: true });

        return header;
    }

    get tasksOfRecurringTaskTableHeaders() {
        const header: Array<any> = [
            // { text: "Tiers", value: "client", align: "left", sortable: true, filterable: { type: 'equals', options:{ toText: (client) => { return this.formatCompany(client) } } } },
            // { text: "Créé par", value: "owner", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (owner) => { return this.formatUserTaskFrom(owner)}}} },
            // { text: "Type", value: "type", align: "left", sortable: true, filterable: { type: 'equals', options:{ toText: (type) => { return this.formatType(type) } } } },
            { text: "Titre", value: "title", align: "left", sortable: false },
            { text: "Description", value: "description", align: "left", sortable: false },
            {
                text: "Attribué à",
                value: "members",
                align: "left",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (members) => {
                            return this.formatSelectedUsers(members);
                        },
                    },
                },
            }, // Pas correct pour members
            // { text: "", value: "", sortable: false },
        ];

        // if (this.isRecurringTaskShow) {
        //     header.push({text: "Début",
        //         value: "start",
        //         align: "center",
        //         sortable: true,
        //     })
        // }

        header.push(
            {
                text: "Début",
                value: "start",
                align: "left",
                sortable: true,
                filterable: { type: "includes", options: { input: "date" } },
            },
            { text: "Statut", value: "status", align: "center", sortable: false },
            { text: "", value: "menu", sortable: false, verticalStickyEnd: true },
        );

        return header;
    }

    get currentUser(): User {
        // debugger
        return this.$store?.state.user;
    }

    displaySelectedUser(user) {
        return getUserDisplayName(user);
    }

    get accountingFirmId() {
        // debugger
        // if (params)
        if (this.isAccountingUser && this.currentUser?.company?.id) {
            return this.currentUser.company.id;
        }
        if (!this.isAccountingUser && this.accountingFirm?.id) {
            return this.accountingFirm.id;
        }
        return "";
    }

    get selectedCompany() {
        return this.$store?.state.selected_company;
    }

    get clientId() {
        // debugger
        return this.selectedCompany?.id;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get tasksLength() {
        if (this.tasks) {
            return this.tasks.length;
        }

        return null;
    }

    tasksOfRecurringTaskLength(tasksOfRecurringTask) {
        if (tasksOfRecurringTask) {
            return tasksOfRecurringTask.length + 1;
        }
    }

    get tasksRecurringLength() {
        if (this.tasksRecurring) {
            return this.tasksDatabase.length;
        }

        return null;
    }

    openUserDialog() {
        this.userDialog = true;
    }

    openMemberDialog() {
        this.memberDialog = true;
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser?.company?.id || this.isAccountingUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    @Apollo({
        query: USER,
        variables() {
            return { id: this.selectedUser.id };
        },
        skip() {
            return !this.selectedUser?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.user) {
                        this.allAvailableCompanies = data.user.allAvailableCompanies;
                        this.user = data.user;
                        debugger;
                    } else {
                        this.allAvailableCompanies = [];
                        this.user = null;
                    }
                }
            }
        },
    })
    user: any = null;

    @Apollo({
        query: TASKS,
        variables() {
            return {
                accountingFirmId: this.accountingFirmId,
                client: { id: this.companySelectedFilter || undefined },
                owner: { id: this.selectedUser?.id ? this.selectedUser.id : undefined },
                member: {
                    id: this.selectedMember?.id ? this.selectedMember.id : undefined,
                },
                status: this.typeStatusFilter !== "ALL" ? this.typeStatusFilter : undefined,
            };
        },
        skip() {
            return !this.accountingFirmId || !this.clientId;
        },
        specificResult({ data, loading }: any) {
            this.loadingTasks = loading;
            if (!loading) {
                if (data?.tasks?.length) {
                    // debugger
                    this.tasksDatabase = data.tasks;
                } else {
                    this.tasksDatabase = [];
                }
            }
        },
    })
    tasksDatabase: any = [];

    @Watch("tasksDatabase", { deep: true })
    sortTasks() {
        this.tasks = [];
        this.tasksRecurring = [];

        if (this.tasksDatabase && this.tasksDatabase.length) {
            for (const taskDatabase of this.tasksDatabase) {
                if (
                    !(
                        taskDatabase.periodicity !== null &&
                        taskDatabase?.tasks &&
                        taskDatabase?.tasks?.length
                    )
                ) {
                    this.tasks.push(taskDatabase);
                } else {
                    if (
                        taskDatabase.periodicity !== null &&
                        taskDatabase.recurringTask === null &&
                        taskDatabase?.tasks?.length
                    ) {
                        this.tasksRecurring.push(taskDatabase);
                    }
                }
            }
        }
    }

    expandedRecurringTasksInTask(taskOfRecurringTask) {
        // debugger

        if (taskOfRecurringTask && taskOfRecurringTask.id) {
            const index = this.expandedTaskIdsInRecurringTask.findIndex(
                (id) => id === taskOfRecurringTask.id,
            );

            if (index !== -1) {
                this.expandedTaskIdsInRecurringTask.splice(index, 1);
            } else {
                this.expandedTaskIdsInRecurringTask.push(taskOfRecurringTask.id);
            }
        }
    }

    taskIdOfRecurringTaskExpanded(taskOfRecurringTaskId) {
        if (taskOfRecurringTaskId) {
            for (const taskId of this.expandedTaskIdsInRecurringTask) {
                if (taskId === taskOfRecurringTaskId) {
                    return true;
                }
            }

            return false;
        }
    }

    clearNewToTaskCreate() {
        //debugger
        this.isNewTask = true;
        this.isEditTask = false;
        this.taskDialog = true;
        this.taskDate = "";
    }

    displayHeaderDate(date: string) {
        if (!date) {
            return "";
        }
        return moment(date, "YYYY-MM").format("MMM");
    }

    clearCompanySelectedFilter() {
        // debugger
        this.companySelectedFilter = "";
    }

    clearStatusSelectedFilter() {
        this.typeStatusFilter = "";
    }

    clearUserSelectedFilter(user, value) {
        if (user) {
            if (user === this.selectedUser && value === 1) {
                this.selectedUser = null;
            } else {
                this.selectedMember = {
                    email: "",
                    firstname: "",
                    id: "",
                    lastname: "",
                    type: "",
                };
            }
        }
    }

    receiveTaskDate(taskDate) {
        debugger;
        if (taskDate) {
            // this.emptyTask()
            this.taskDate = taskDate;
            this.isNewTask = true;
            this.isEditTask = false;
            this.taskDialog = true;
        }
    }

    editTask(task) {
        if (task) {
            // debugger
            this.isNewTask = false;
            this.isEditTask = true;
            this.taskReceive = JSON.parse(JSON.stringify(task));
            this.taskDialog = true;
        }
    }

    editTaskOfRecurringTask(date, tasksOfRecurringTask) {
        if (tasksOfRecurringTask && date) {
            // debugger
            for (const taskOfRecurringTask of tasksOfRecurringTask) {
                let startDateTask = moment(taskOfRecurringTask.start).format("YYYY-MM");

                if (startDateTask === date) {
                    this.taskReceive = JSON.parse(JSON.stringify(taskOfRecurringTask));
                    this.isEditTask = true;
                    this.isNewTask = false;
                    this.taskDialog = true;
                }
            }
        }
    }

    // isRecurringTasksInTask(tasksOfRecurringTask) {
    //     debugger
    //     if (tasksOfRecurringTask) {
    //         return true
    //     }

    //     return false
    // }

    async deleteTask(taskToDelete) {
        if (taskToDelete) {
            // debugger

            console.log("task", taskToDelete.id);
            this.taskDeleleteIds.push(taskToDelete.id);

            if (taskToDelete.tasks) {
                for (const taskOfRecurringTask of taskToDelete.tasks) {
                    this.taskDeleleteIds.push(taskOfRecurringTask.id);
                }
            }
            if (this.taskDeleleteIds.length) {
                const result = await this.$apollo.mutate({
                    mutation: DELETE_TASK,
                    variables: {
                        ids: this.taskDeleleteIds,
                    },
                });
                this.taskDeleleteIds = [];

                if (result) {
                    // this.$apollo.queries.tasksDatabase.refetch()
                    this.tasksDatabase = this.tasksDatabase.filter(
                        (task) => task.id !== taskToDelete.id,
                    );
                }
            }
        }
    }

    // async deleteTaskOfRecurringTask(date,tasksOfRecurringTask) {
    //     if (tasksOfRecurringTask && date) {

    //         // debugger
    //         for (const taskOfRecurringTask of tasksOfRecurringTask) {

    //             let startDateTask = moment(taskOfRecurringTask.start).format("YYYY-MM")

    //             if (startDateTask === date ) {
    //                 this.taskDeleleteIds.push(taskOfRecurringTask.id)

    //                 const result = await this.$apollo.mutate({
    //                     mutation: DELETE_TASK,
    //                     variables:{
    //                         ids: this.taskDeleleteIds
    //                     }
    //                 })
    //                 this.taskDeleleteIds = []

    //                 if (result) {
    //                     this.$apollo.queries.tasksDatabase.refetch()
    //                     this.tasksDatabase = this.tasksDatabase.filter(task => task.id !== taskOfRecurringTask.id)
    //                 }
    //             }

    //         }
    //     }
    // }

    receiveTask() {
        // debugger
        // if (task) {
        //     this.$apollo.queries.tasksDatabase.refetch()
        // }
        this.$apollo.queries.tasksDatabase.refetch();
    }

    onDateRangeChanged(data) {
        this.startPeriodicityDate = data.begin;
        this.endPeriodicityDate = data.end;
    }

    formatCompany(client) {
        if (client) {
            // debugger
            return client.name;
        }
        return "";
    }

    formatStatus(status) {
        if (status) {
            switch (status) {
                case "TO_BE_DONE":
                    return "En cours";
                case "DONE":
                    return "Terminée";
            }
        }
    }

    formatPeriodicity(periodicity) {
        if (periodicity) {
            switch (periodicity) {
                case null:
                    return "Aucune";
                case "MONTHLY":
                    return "Mensuel";
                case "QUARTERLY":
                    return "Trimestriel";
                case "ANNUAL":
                    return "Annuel";
            }
        }
    }

    formatType(type) {
        if (type) {
            switch (type) {
                case "MISCELLANEOUS":
                    return "Divers";
                case "VAT":
                    return "TVA";
                case "IS":
                    return "IS";
            }
        }
    }

    formatUserTaskFrom(owner) {
        if (owner) {
            return owner.firstname + " " + owner.lastname;
        }
        return "";
    }

    formatSelectedUsers(members) {
        if (members) {
            // debugger
            let nbUsers = 0;
            nbUsers = members.length - 1;
            for (const selectedUser of members) {
                if (members.length < 2) {
                    return selectedUser.firstname + " " + selectedUser.lastname;
                } else {
                    return (
                        members[0].firstname +
                        " " +
                        members[0].lastname +
                        " +" +
                        nbUsers +
                        " personne(s)"
                    );
                }
            }
        }
        return "";
    }

    formatDate(dueDate) {
        if (!dueDate) return "";
        return moment(dueDate).format("DD/MM/YYYY");
    }

    // formatStartDate(task) {

    //     debugger
    //     if ( (task.start === task.dueDate) && (task?.tasks && task?.tasks?.length) ) {
    //         return ""
    //     }

    //     return moment(task.start).format("DD/MM/YYYY")
    // }

    formatDateHeader(date) {
        const fDate = date;
        return fDate;
    }

    nextDate(date) {
        return moment(date, "YYYY-MM").add(1, "M").format("YYYY-MM");
    }

    // isEndIteration(date) {
    //     return moment(date, "YYYY-MM").isSameOrBefore(
    //         moment(this.formatDateHeader(this.endPeriodicityDate), "YYYY-MM")
    //     );
    // }

    checkStartDateTask(dateHeader, tasksOfRecurringTask) {
        // debugger
        // let taskIndex
        // let isStartDate = false

        if (dateHeader && tasksOfRecurringTask) {
            for (const dateTaskOfRecurringTask of tasksOfRecurringTask) {
                let startDateTask = moment(dateTaskOfRecurringTask.start).format("YYYY-MM");

                if (dateHeader === startDateTask) {
                    return true;
                }
            }
        }
        return false;
    }

    @Watch("selectedUser", { deep: true })
    refreshUserTasks() {
        debugger;
        // this.currentUser
        // this.selectedUser
        this.$apollo.queries.tasksDatabase.refetch();
    }

    // @Watch('typeStatusFilter' , { deep : true })
    // typeStatusFilterValue() {
    //     debugger
    //     // this.currentUser
    //     // this.selectedUser
    //     this.typeStatusFilter
    // }

    async changeTaskStatus(date, tasksOfRecurringTask, taskOfRecurringTask, taskNormal) {
        // On fournit une tâche spécifique
        if (taskNormal) {
            if (taskNormal.status === "DONE") {
                taskNormal.status = "TO_BE_DONE";
            } else {
                taskNormal.status = "DONE";
            }
            if (taskNormal?.id) {
                await this.$apollo.mutate({
                    mutation: UPSERT_TASK,
                    variables: {
                        id: taskNormal.id,
                        status: taskNormal.status,
                    },
                });
            }
        }

        if (taskOfRecurringTask) {
            if (taskOfRecurringTask.status === "DONE") {
                taskOfRecurringTask.status = "TO_BE_DONE";
            } else {
                taskOfRecurringTask.status = "DONE";
            }
            if (taskOfRecurringTask?.id) {
                await this.$apollo.mutate({
                    mutation: UPSERT_TASK,
                    variables: {
                        id: taskOfRecurringTask.id,
                        status: taskOfRecurringTask.status,
                        recurringTask: taskOfRecurringTask.recurringTask.id,
                    },
                });
            }
        }

        // On fournit la liste des tâches de la tâche récurrente
        if (tasksOfRecurringTask && date) {
            debugger;
            for (const statusTaskOfRecurringTask of tasksOfRecurringTask) {
                let startDateTask = moment(statusTaskOfRecurringTask.start).format("YYYY-MM");

                if (startDateTask === date) {
                    if (statusTaskOfRecurringTask.status === "DONE") {
                        statusTaskOfRecurringTask.status = "TO_BE_DONE";
                    } else {
                        statusTaskOfRecurringTask.status = "DONE";
                    }
                    if (statusTaskOfRecurringTask?.id) {
                        await this.$apollo.mutate({
                            mutation: UPSERT_TASK,
                            variables: {
                                id: statusTaskOfRecurringTask.id,
                                status: statusTaskOfRecurringTask.status,
                                recurringTask: statusTaskOfRecurringTask.recurringTask.id,
                            },
                        });
                    }
                }
            }
        }
    }

    changeColorTaskStatus(date, tasksOfRecurringTask) {
        debugger;

        let todayDate = new Date();

        if (tasksOfRecurringTask && date) {
            for (const statusTaskOfRecurringTask of tasksOfRecurringTask) {
                let startDateTask = moment(statusTaskOfRecurringTask.start).format("YYYY-MM");

                if (
                    moment(startDateTask).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD")
                ) {
                    //     if (statusTaskOfRecurringTask.status === 'DONE') {
                    //         return 'green'
                    //     }
                    // } else {
                    //     if ((moment(startDateTask).format('YYYY-MM-DD') >= moment(todayDate).format('YYYY-MM-DD')) && (statusTaskOfRecurringTask.status === 'TO_BE_DONE')) {
                    //         return 'red'
                    //     } else {
                    //         return 'grey'
                    //     }
                    //
                    switch (statusTaskOfRecurringTask.status) {
                        case "TO_BE_DONE": {
                            const endDateString = moment(statusTaskOfRecurringTask.dueDate).format(
                                "YYYY-MM-DD",
                            );
                            const dueDate = new Date(endDateString);

                            if (dueDate < todayDate) {
                                return "red";
                            } else {
                                return "grey";
                            }
                        }
                        case "DONE": {
                            return "green";
                        }
                    }
                }
            }
        }

        return "red";
    }

    statusIcon(status) {
        //debugger
        if (status) {
            if (status === "TO_BE_DONE") {
                return "$oss-circle-uncheck";
            }
            if (status === "DONE") {
                return "$fa-check-circle";
            }
        }
    }

    // setSpanType(type) {
    //     if (type) {
    //         if (type === "MISCELLANEOUS") {
    //             return "D"
    //         } else {
    //             return "T"
    //         }
    //     }
    // }

    displayDateAvatar(date) {
        if (date) {
            return moment(date).format("D");
        }

        return "";
    }

    setStatusTaskOfRecurringTask(date, tasksOfRecurringTask) {
        const todayDate = new Date();

        if (tasksOfRecurringTask && date) {
            for (const statusTaskOfRecurringTask of tasksOfRecurringTask) {
                let startDateTask = moment(statusTaskOfRecurringTask.start).format("YYYY-MM");

                if (startDateTask === date) {
                    switch (statusTaskOfRecurringTask.status) {
                        case "TO_BE_DONE": {
                            const endDateString = moment(statusTaskOfRecurringTask.dueDate).format(
                                "YYYY-MM-DD",
                            );
                            const dueDate = new Date(endDateString);

                            if (dueDate < todayDate) {
                                return "Date d'échéance dépassée";
                            } else {
                                return "En cours";
                            }
                        }
                        case "DONE": {
                            return "Terminée";
                        }
                    }
                }
            }
        }

        return "";
    }

    statusColor(task) {
        const todayDate = new Date();

        //debugger
        if (task) {
            if (task.status === "TO_BE_DONE") {
                const endDateString = moment(task.dueDate).format("YYYY-MM-DD");
                const dueDate = new Date(endDateString);

                if (dueDate < todayDate) {
                    return "red";
                } else {
                    return "magic";
                }
            }
            if (task.status === "DONE") {
                return "secondary";
            }
        }
    }

    statusText(task) {
        const todayDate = new Date();

        //debugger
        if (task) {
            switch (task.status) {
                case "TO_BE_DONE": {
                    const endDateString = moment(task.dueDate).format("YYYY-MM-DD");
                    const dueDate = new Date(endDateString);

                    if (dueDate < todayDate) {
                        return "Date d'échéance dépassée";
                    } else {
                        return "En cours";
                    }
                }
                case "DONE": {
                    return "Terminée";
                }
            }
        }
    }
}

export default toNative(Tasks);
</script>
